// Class ability + universal move reference for the Dossier's "Class ability"
// panel. Values MUST mirror backend/src/game/mobfight/mobfight.combat.ts
// exactly — verified against ABILITY and resolveRound() on 2026-07-10.
import type { HeroClass } from './hero-api';
import { t } from '../i18n';

export interface ClassAbilityInfo {
  name: string;
  cooldown: number; // rounds until ready again
  desc: string;
}

/** Class signature move — mirrors mobfight.combat.ts:ABILITY. Translated at access time. */
export const CLASS_ABILITY: Record<HeroClass, ClassAbilityInfo> = {
  WARRIOR: { get name() { return t('abilities.WARRIOR.name'); }, cooldown: 3, get desc() { return t('abilities.WARRIOR.desc'); } },
  PALADIN: { get name() { return t('abilities.PALADIN.name'); }, cooldown: 4, get desc() { return t('abilities.PALADIN.desc'); } },
  ARCHER:  { get name() { return t('abilities.ARCHER.name'); },  cooldown: 3, get desc() { return t('abilities.ARCHER.desc'); } },
  MAGE:    { get name() { return t('abilities.MAGE.name'); },    cooldown: 3, get desc() { return t('abilities.MAGE.desc'); } },
};

/** Universal mob-fight moves every class shares, for the reference strip under
 *  the class ability card. Mirrors resolveRound()'s constants. */
export const UNIVERSAL_MOVES: { name: string; desc: string }[] = [
  { get name() { return t('abilities.strike.name'); }, get desc() { return t('abilities.strike.desc'); } },
  { get name() { return t('abilities.heavy.name'); }, get desc() { return t('abilities.heavy.desc'); } },
  { get name() { return t('abilities.guard.name'); }, get desc() { return t('abilities.guard.desc'); } },
];
